module.exports = "../dist/img/product-detail-4-17.92bb.jpg";